import { Col } from '@design-system/components/grid/grid';
import { Typography } from '@design-system/components/typography/typography';
import { Controller } from 'react-hook-form';
import { Checkbox } from '@design-system/components/checkbox/checkbox';
import { InputPrice } from '@design-system/components/input/inputPrice';
import { faDollar } from '@fortawesome/pro-regular-svg-icons';
import { sprinkles } from '@design-system/sprinkles.css';
import {
  enablePriceWrapper,
  inputWrapper,
  priceWrapper,
} from './PriceInput.css';
import { MigrationModalProps } from '../migration/modal/MigrationModal';

export const PriceInput = ({
  control,
  transformPrice,
}: Pick<MigrationModalProps, 'control' | 'transformPrice'>) => {
  return (
    <>
      <div className={priceWrapper}>
        <Controller
          name="monthlyPriceEnabled"
          control={control}
          render={({ field: { onChange, value } }) => (
            <div className={enablePriceWrapper}>
              <Checkbox
                checked={value as boolean}
                onChange={onChange}
                wrapperClassName="p-4"
                checkboxVariant="neutral"
                testId="monthly-price-checkbox"
              />
              <Typography>Price per month</Typography>
            </div>
          )}
        />
        <div className={inputWrapper}>
          <Controller
            name="monthlyPrice"
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <InputPrice
                value={value as string}
                onChange={onChange}
                startIcon={{
                  icon: faDollar,
                  className: sprinkles({ color: 'N-80' }),
                }}
                supportingText="Min. value $1.00"
                placeholder="00.00"
                hasError={!!error}
                onBlur={() => {
                  value && transformPrice(value, 'monthlyPrice');
                }}
                testId="monthly-price-input"
              />
            )}
          />
        </div>
      </div>
      <div className={priceWrapper}>
        <Controller
          name="annualPriceEnabled"
          control={control}
          render={({ field: { onChange, value } }) => (
            <div className={enablePriceWrapper}>
              <Checkbox
                checked={value as boolean}
                onChange={onChange}
                wrapperClassName="p-4"
                checkboxVariant="neutral"
                testId="annual-price-checkbox"
              />
              <Typography>Price per year</Typography>
            </div>
          )}
        />
        <div className={inputWrapper}>
          <Controller
            name="annualPrice"
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <InputPrice
                value={value as string}
                onChange={onChange}
                startIcon={{
                  icon: faDollar,
                  className: sprinkles({ color: 'N-80' }),
                }}
                supportingText="Min. value $10.00"
                placeholder="00.00"
                hasError={!!error}
                onBlur={() => {
                  value && transformPrice(value, 'annualPrice');
                }}
                testId="annual-price-input"
              />
            )}
          />
        </div>
      </div>
    </>
  );
};
